import { simpleCopy } from '@/utils/deepCopy';

/**
 * 演算子の定義
 */
export type NumberInput = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '0' | '.';

const _NUMBER_INPUTS: readonly NumberInput[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.'];

/**
 * 演算子の取得
 * @returns Operator[]
 */
export const getNumberInputs = (): readonly NumberInput[] => {
  return simpleCopy(_NUMBER_INPUTS);
};

/**
 * 演算子(数字）の表示名を取得する
 * @param numberInput - 演算子
 */
export const getDisplayNumbers = (numberInput: NumberInput): string => {
  switch (numberInput) {
    case '1':
      return '1';
    case '2':
      return '2';
    case '3':
      return '3';
    case '4':
      return '4';
    case '5':
      return '5';
    case '6':
      return '6';
    case '7':
      return '7';
    case '8':
      return '8';
    case '9':
      return '9';
    case '0':
      return '0';
    case '.':
      return '.';
  }
};
